"use strict";

var _interopRequireDefault = require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _classNames = _interopRequireDefault(require("../classNames"));
var _excluded = ["className"];
var _jsxFileName = "/Users/mweeb/Desktop/codings/nq-component/src/Spinner/index.js";
var defaultProps = {
  size: "sm"
};
function Spinner(_ref) {
  var className = _ref.className,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var size = 'spinner-border-' + props.size;
  var classes = (0, _classNames["default"])("spinner-border text-secondary", size, className);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "d-flex justify-content-center align-items-center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 12,
      columnNumber: 9
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes,
    role: "status",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13,
      columnNumber: 13
    }
  }));
}
Spinner.defaultProps = defaultProps;
var _default = Spinner;
exports["default"] = _default;